import React from "react";
import { useState } from "react";

const AppBar = ({ slides, onSelectSlide }) => {
    const [selectedSlideIndex, setSelectedSlideIndex] = useState(0);

    return <>
        <div className="horizontalFlexContainer">
            {
                slides.map((slide, index) => {
                    return <div
                        key={index}
                        style={{
                            flex: "1",
                            textAlign: "center",
                            height: "40px",
                            cursor: "pointer",
                            color: index === selectedSlideIndex ? "var(--primary-base)" : "var(--carbone)",
                            borderBottom: index === selectedSlideIndex ? "4px solid var(--primary-base)" : "1px solid var(--carbone)"
                        }}
                        onClick={() => {
                            if (selectedSlideIndex !== index) {
                                setSelectedSlideIndex(index);
                                if (onSelectSlide) {onSelectSlide(slide);}
                            }
                        }}
                    >
                        {slide.title}
                    </div>;
                })
            }
        </div>
        {
            slides[selectedSlideIndex].content
        }
    </>;
};

export default AppBar;
